export const GetDistance = (lat1, lon1, lat2, lon2) => {
    if ((lat1 === lat2) && (lon1 === lon2)) {
        return 0;
    }
    else {
        var radlat1 = Math.PI * lat1 / 180;
        var radlat2 = Math.PI * lat2 / 180;
        var theta = lon1 - lon2;
        var radtheta = Math.PI * theta / 180;
        var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        if (dist > 1) {
            dist = 1;
        }
        dist = Math.acos(dist);
        dist = dist * 180 / Math.PI;
        dist = dist * 60 * 1.1515;
        dist = dist * 1.609344;
        return dist;
    }
};

export const GetTripDistance = async (data) => {
    if (data) {
        const arr = Object.keys(data)
            .filter(function (i) {
                return data[i].status == 'STARTED' || data[i].status == 'REACHED'
            })
            .map(i => {
                data[i].id = i
                return data[i]
            });
        let distance = 0;
        let coords = [];
        try {
            if (arr.length == 0 || arr.length == 1) {
                distance = 0;
            } else if (arr.length == 2) {
                distance = GetDistance(arr[0].lat, arr[0].lng, arr[1].lat, arr[1].lng);
                coords.push({ latitude: arr[0].lat, longitude: arr[0].lng });
                coords.push({ latitude: arr[1].lat, longitude: arr[1].lng });
            } else {
                for (let i = 0; i < (arr.length - 1); i++) {
                    distance = distance + GetDistance(arr[i].lat, arr[i].lng, arr[i + 1].lat, arr[i + 1].lng)
                    coords.push({ latitude: arr[i].lat, longitude: arr[i].lng });
                }
                coords.push({ latitude: arr[arr.length - 1].lat, longitude: arr[arr.length - 1].lng });
            }
        } catch (error) {
            console.log(error);
        }
        return {
            distance: distance,
            coords: coords
        };
    }
    else {
        return {
            distance: 0,
            coords: []
        };
    }
}

// Helper to get lat/lng safely
const getLat = (p) => p.lat !== undefined ? p.lat : p.latitude;
const getLng = (p) => p.lng !== undefined ? p.lng : p.longitude;

// Ray-casting algorithm for point in polygon
export const isPointInPolygon = (point, polygon) => {
    const x = getLat(point), y = getLng(point);
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = getLat(polygon[i]), yi = getLng(polygon[i]);
        const xj = getLat(polygon[j]), yj = getLng(polygon[j]);

        const intersect = ((yi > y) !== (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }
    return inside;
};

export const isPointInCircle = (point, center, radius) => {
    const lat1 = getLat(point);
    const lng1 = getLng(point);
    const lat2 = getLat(center);
    const lng2 = getLng(center);

    if (lat1 === undefined || lng1 === undefined || lat2 === undefined || lng2 === undefined) return false;

    const km = GetDistance(lat1, lng1, lat2, lng2);
    const m = km * 1000;
    return m <= radius;
};


export const getZoneForPoint = (point, zones) => {
    if (!point || !zones) return null;

    // Normalize zones to array of objects with their ID attached
    let zonesArray = [];
    if (Array.isArray(zones)) {
        zonesArray = zones;
    } else {
        // Firebase object structure: { key1: {name...}, key2: {name...} }
        // We MUST preserve the key as 'id'
        zonesArray = Object.keys(zones).map(key => ({ ...zones[key], id: key }));
    }

    if (zonesArray.length === 0) return null;

    const matches = [];

    for (const zone of zonesArray) {
        let inside = false;

        // Default to active if undefined
        const active = zone.isActive !== false;

        if (active) {
            if (zone.type === 'circle' && zone.center) {
                if (isPointInCircle(point, zone.center, zone.radius)) inside = true;
            } else if (zone.type === 'polygon' && zone.coordinates) {
                if (isPointInPolygon(point, zone.coordinates)) inside = true;
            }
        }

        if (inside) {
            matches.push(zone);
        }
    }

    if (matches.length === 0) return null;

    // Sort by priority if available, else return first
    // Treat undefined priority as 0. 
    // Higher priority first.
    return matches.sort((a, b) => (b.priority || 0) - (a.priority || 0))[0];
};

/**
 * [V2.0.1] Shared place type detectors with Place Types support
 */
export const isAirport = (address) => {
    if (!address) return false;
    // 1. Check Google Place Types
    let matchType = false;
    if (typeof address === 'object' && address.placeDetails && address.placeDetails.types) {
        matchType = address.placeDetails.types.includes("airport");
    }
    // 2. Check Name/String
    const addrString = typeof address === "string" 
        ? address 
        : (address.address || address.description || address.formatted_address || "");
    const lowerAddress = String(addrString).toLowerCase();
    const matchName = lowerAddress.includes('aéroport') || 
                      lowerAddress.includes('airport') || 
                      lowerAddress.includes('terminal') ||
                      lowerAddress.includes('flughafen') ||
                      lowerAddress.includes('aeropuerto') ||
                      lowerAddress.includes('(cdg)') ||
                      lowerAddress.includes('(ory)') ||
                      lowerAddress.includes('(bod)');
    return matchType || matchName;
};

export const isStation = (address) => {
    if (!address) return false;
    // 1. Check Google Place Types
    let matchType = false;
    if (typeof address === 'object' && address.placeDetails && address.placeDetails.types) {
        matchType = address.placeDetails.types.includes("train_station") ||
                    address.placeDetails.types.includes("transit_station");
    }
    // 2. Check Name/String
    const addrString = typeof address === "string" 
        ? address 
        : (address.address || address.description || address.formatted_address || "");
    const lowerAddress = String(addrString).toLowerCase();
    const matchName = lowerAddress.includes('gare') || 
                      lowerAddress.includes('station') || 
                      lowerAddress.includes('railway') ||
                      lowerAddress.includes('bahnhof') ||
                      lowerAddress.includes('estación') ||
                      lowerAddress.includes('train');
    return matchType || matchName;
};

/**
 * Normalise une chaîne d'adresse pour comparaison textuelle
 */
export const normalizeAddressString = (addr) => {
    if (!addr || typeof addr !== 'string') return '';
    return addr
        .toLowerCase()
        .replace(/œ/g, 'oe')
        .replace(/æ/g, 'ae')
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .replace(/[^\w\s]/gi, ' ')
        .replace(/\s+/g, ' ')
        .trim();
};

/**
 * Détermine si deux localisations représentent le même endroit (par place_id, texte normalisé ou coordonnées GPS)
 */
export const isSameLocation = (loc1, loc2, minDistanceKm = 0.05) => {
    if (!loc1 || !loc2) return false;

    // 1. Identifiant Google Place ID
    if (loc1.place_id && loc2.place_id && loc1.place_id === loc2.place_id) {
        return true;
    }

    // 2. Comparaison des chaînes d'adresses normalisées
    const add1 = loc1.add || loc1.description || loc1.address || loc1.name || (typeof loc1 === 'string' ? loc1 : null);
    const add2 = loc2.add || loc2.description || loc2.address || loc2.name || (typeof loc2 === 'string' ? loc2 : null);
    if (add1 && add2) {
        const norm1 = normalizeAddressString(String(add1));
        const norm2 = normalizeAddressString(String(add2));
        if (norm1 && norm2 && norm1 === norm2) {
            return true;
        }
    }

    // 3. Comparaison des coordonnées GPS (lat / lng)
    const lat1 = Number(loc1.lat ?? loc1.latitude ?? loc1.coords?.lat);
    const lng1 = Number(loc1.lng ?? loc1.longitude ?? loc1.coords?.lng);
    const lat2 = Number(loc2.lat ?? loc2.latitude ?? loc2.coords?.lat);
    const lng2 = Number(loc2.lng ?? loc2.longitude ?? loc2.coords?.lng);

    if (!isNaN(lat1) && !isNaN(lng1) && !isNaN(lat2) && !isNaN(lng2) && (lat1 !== 0 || lng1 !== 0)) {
        if (lat1 === lat2 && lng1 === lng2) {
            return true;
        }
        const distKm = GetDistance(lat1, lng1, lat2, lng2);
        if (distKm <= minDistanceKm) {
            return true;
        }
    }

    return false;
};

/**
 * Valide si un trajet départ -> arrivée est interdit car le départ et l'arrivée sont identiques
 * Règle : Interdit pour un trajet direct simple (sans étapes distinctes).
 * Autorisé si le trajet comporte des étapes intermédiaires distinctes (ex: A -> B -> A).
 */
export const isTripSamePickupDrop = (pickup, drop) => {
    if (!pickup || !drop) return false;

    // Récupérer les étapes éventuelles
    const rawWaypoints = (drop.waypoints && Array.isArray(drop.waypoints) && drop.waypoints.length > 0)
        ? drop.waypoints
        : (drop.selectedWaypoints && Array.isArray(drop.selectedWaypoints))
            ? drop.selectedWaypoints
            : [];

    if (rawWaypoints.length > 0) {
        // Trajet à étapes : valide si au moins une étape est distincte du point de départ
        const hasDistinctWaypoint = rawWaypoints.some(wp => !isSameLocation(pickup, wp));
        if (hasDistinctWaypoint) {
            return false; // Trajet circuit / aller-retour avec étape(s) valide
        }
    }

    // Pas d'étapes distinctes : vérifier si départ et arrivée sont identiques
    return isSameLocation(pickup, drop);
};

/**
 * Configuration par défaut de la zone principale d'exploitation (Bordeaux / Gironde)
 */
export const DEFAULT_SERVICE_AREA = {
    cityName: "Bordeaux, France",
    shortCityName: "Bordeaux",
    lat: 44.8378,
    lng: -0.5792,
    radiusKm: 80,
    country: "FR",
    enforceServiceArea: true,
};

/**
 * Résout la configuration de la ville principale et de son rayon depuis settings
 */
export const getServiceAreaConfig = (settings) => {
    const enforceServiceArea = settings?.enforceServiceArea !== undefined
        ? Boolean(settings.enforceServiceArea)
        : DEFAULT_SERVICE_AREA.enforceServiceArea;

    const cityName = (typeof settings?.serviceCityName === "string" && settings.serviceCityName.trim() !== "")
        ? settings.serviceCityName.trim()
        : DEFAULT_SERVICE_AREA.cityName;

    const shortCityName = cityName.split(",")[0].trim() || DEFAULT_SERVICE_AREA.shortCityName;

    const parsedLat = parseFloat(settings?.serviceCityLat);
    const parsedLng = parseFloat(settings?.serviceCityLng);
    const lat = !isNaN(parsedLat) && parsedLat !== 0 ? parsedLat : DEFAULT_SERVICE_AREA.lat;
    const lng = !isNaN(parsedLng) && parsedLng !== 0 ? parsedLng : DEFAULT_SERVICE_AREA.lng;

    const parsedRadius = parseFloat(settings?.serviceAreaRadiusKm);
    const radiusKm = !isNaN(parsedRadius) && parsedRadius > 0
        ? parsedRadius
        : DEFAULT_SERVICE_AREA.radiusKm;

    const country = (typeof settings?.serviceCityCountry === "string" && settings.serviceCityCountry.trim() !== "")
        ? settings.serviceCityCountry.trim().toUpperCase()
        : DEFAULT_SERVICE_AREA.country;

    const latDelta = radiusKm / 111.32;
    const cosLat = Math.max(0.1, Math.cos((lat * Math.PI) / 180));
    const lngDelta = radiusKm / (111.32 * cosLat);

    const bounds = {
        center: { lat, lng },
        radius: Math.round(radiusKm * 1000),
        north: Number((lat + latDelta).toFixed(4)),
        south: Number((lat - latDelta).toFixed(4)),
        east: Number((lng + lngDelta).toFixed(4)),
        west: Number((lng - lngDelta).toFixed(4)),
    };

    return {
        enforceServiceArea,
        cityName,
        shortCityName,
        lat,
        lng,
        radiusKm,
        country,
        bounds,
    };
};

/**
 * Extrait les coordonnées { lat, lng } d'un objet adresse quel que soit son format (Web, Mobile, Backend)
 */
export const extractLocationCoords = (loc) => {
    if (!loc || typeof loc !== "object") return null;
    const rawLat = loc.coords?.lat ?? loc.lat ?? loc.latitude ?? loc.geometry?.location?.lat;
    const rawLng = loc.coords?.lng ?? loc.lng ?? loc.longitude ?? loc.geometry?.location?.lng;
    const lat = typeof rawLat === "function" ? rawLat() : Number(rawLat);
    const lng = typeof rawLng === "function" ? rawLng() : Number(rawLng);
    if (!isNaN(lat) && !isNaN(lng) && (lat !== 0 || lng !== 0)) {
        return { lat, lng };
    }
    return null;
};

/**
 * Vérifie si une localisation se situe dans le rayon configuré autour de la ville principale
 */
export const isLocationInServiceArea = (loc, settings) => {
    if (!loc) return true;
    const config = getServiceAreaConfig(settings);
    if (!config.enforceServiceArea) return true;

    const coords = extractLocationCoords(loc);
    if (coords) {
        const distKm = GetDistance(coords.lat, coords.lng, config.lat, config.lng);
        return distKm <= config.radiusKm;
    }

    // Fallback textuel si les coordonnées ne sont pas encore résolues
    const addrText = String(loc.description || loc.add || loc.address || loc.formatted_address || "").toLowerCase();
    if (!addrText) return true;
    const shortLower = config.shortCityName.toLowerCase();
    if (shortLower && addrText.includes(shortLower)) return true;
    if (shortLower === "bordeaux" && /\b33\d{3}\b/.test(addrText)) return true;

    return false;
};

/**
 * Valide qu'un trajet respecte la zone d'exploitation :
 * - En mode "hourly" (mise à disposition) : le départ doit être dans le rayon de la ville principale.
 * - En mode "one_way" / "round_trip" : le départ OU l'arrivée doit être dans le rayon de la ville principale.
 */
export const isTripWithinServiceArea = (pickup, drop, settings, tripType = "one_way") => {
    const config = getServiceAreaConfig(settings);
    if (!config.enforceServiceArea) {
        return { valid: true, pickupInArea: true, dropInArea: true, config };
    }

    if (!pickup) {
        return { valid: true, pickupInArea: true, dropInArea: true, config };
    }

    const pickupCoords = extractLocationCoords(pickup);
    const pickupAddr = pickup.description || pickup.add || pickup.address;
    if (!pickupCoords && !pickupAddr) {
        return { valid: true, pickupInArea: true, dropInArea: true, config };
    }

    const pickupInArea = isLocationInServiceArea(pickup, settings);

    if (tripType === "hourly") {
        return {
            valid: pickupInArea,
            pickupInArea,
            dropInArea: true,
            config,
        };
    }

    if (!drop) {
        return { valid: true, pickupInArea, dropInArea: true, config };
    }

    const dropCoords = extractLocationCoords(drop);
    const dropAddr = drop.description || drop.add || drop.address;
    if (!dropCoords && !dropAddr) {
        return { valid: true, pickupInArea, dropInArea: true, config };
    }

    const dropInArea = isLocationInServiceArea(drop, settings);
    return {
        valid: pickupInArea || dropInArea,
        pickupInArea,
        dropInArea,
        config,
    };
};
